import { render, staticRenderFns } from "./CampaignBuilderLoader.vue?vue&type=template&id=495520be&scoped=true&"
import script from "./CampaignBuilderLoader.vue?vue&type=script&lang=js&"
export * from "./CampaignBuilderLoader.vue?vue&type=script&lang=js&"
import style0 from "./CampaignBuilderLoader.vue?vue&type=style&index=0&id=495520be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495520be",
  null
  
)

export default component.exports